import { render, staticRenderFns } from "./fund-search-error.vue?vue&type=template&id=fb1e841c&scoped=true&lang=pug"
import script from "./fund-search-error.vue?vue&type=script&setup=true&lang=js"
export * from "./fund-search-error.vue?vue&type=script&setup=true&lang=js"
import style0 from "./fund-search-error.vue?vue&type=style&index=0&id=fb1e841c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e841c",
  null
  
)

export default component.exports